<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditAsset"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editAsset"
          class="fixed max-h-screen overflow-y-auto center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Asset</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Unique Number</label>
              <input
                v-model="info.AssetNo"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Serial Number</label>
              <input
                v-model="info.SerialNumber"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Type</label>
              <!-- {{ info }} -->
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.AssetType"
                placeholder="Select a type"
                @change="findAssetTypeByName"
              >
                <el-option
                  v-for="assetType in assetTypes"
                  :key="assetType.Name"
                  :label="assetType.Name"
                  :value="assetType.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Asset Status</label>

              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.AssetStatus"
                placeholder="Select a status"
                @change="findAssetStatusByName"
              >
                <el-option
                  v-for="status in assetStatuses"
                  :key="status.Name"
                  :label="status.Name"
                  :value="status.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Brand Name</label>
              <!-- {{ info }} -->
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.AssetBrand"
                placeholder="Select a type"
                @change="findModelByBrandName"
              >
                <el-option
                  v-for="brand in assetBrand"
                  :key="brand.Name"
                  :label="brand.Name"
                  :value="brand.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Model</label>
              <!-- {{ info }} -->
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.AssetModel"
                placeholder="Select a type"
                :disabled="!info.AssetBrand"
              >
                <el-option
                  v-for="model in modelsToSelect"
                  :key="model.Name"
                  :label="model.Name"
                  :value="model.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Condition</label>
              <!-- {{ info }} -->
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.AssetCondition"
                placeholder="Select a type"
                @change="findAssetConditionByName"
              >
                <el-option
                  v-for="cond in condition"
                  :key="cond.Name"
                  :label="cond.Name"
                  :value="cond.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                v-model="info.Description"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-md w-full"
                rows="4"
                maxlength="500"
                autocorrect="en-US"
              ></textarea>
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5 hidden">
            <div class="text-sm">
              <label class="block pb-1">Status</label>
              <input
                v-model="info.Status"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
              @click="editAsset"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "EditAsset",
  props: ["showEditAsset", "reload", "info"],
  components: { Loader },
  data() {
    return {
      edit_error: null,
      edit_success: null,
      loading: false,
      assetStatuses: [],
      assetTypes: [],
      brand: [],
      condition: [],
      assetModel: [],
      assetBrand: [],
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  created() {
    this.getAssetTypes();
    this.getAssetStatuses();
    this.getAssetBrand();
    this.getAssetCondition();
    this.getAssetModel();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    findModelByBrandName(brandName) {
      this.modelsToSelect = this.assetModel.filter(
        (model) => model.Brand === brandName
      );
    },

    // /{organization}/asset/v1/edit
    editAsset() {
      const data = {
        AssetId: this.info.Id,
        AssetNo: this.info.AssetNo,
        SerialNumber: this.info.SerialNumber,
        AssetTypeId: this.assetTypes.find(
          (assetType) => assetType.Name === this.info.AssetType
        ).Id,
        AssetStatusId: this.assetStatuses.find(
          (assetStatus) => assetStatus.Name === this.info.AssetStatus
        ).Id,
        AssetConditionId: this.condition.find(
          (cond) => cond.Name === this.info.AssetCondition
        ).Id,
        AssetModelId: this.assetModel.find(
          (model) => model.Name === this.info.AssetModel
        ).Id,
        AssetBrandId: this.assetBrand.find(
          (brand) => brand.Name === this.info.AssetBrand
        ).Id,
        Name: this.info.Name,
        Description: this.info.Description,
        Status: parseInt(this.info.Status),
      };

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/asset/${this.$ApiVersion}/edit`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.reload();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
            }, 2500);
          }
        );
    },

    findAssetTypeByName(selectedAsset) {
      this.info.AssetTypeId = this.assetTypes.find(
        (asset) => asset.Name == selectedAsset
      ).Id;
    },
    findAssetModelByName(selectedAsset) {
      this.info.AssetModelId = this.assetModel.find(
        (model) => model.Name == selectedAsset
      ).Id;
    },
    findAssetConditionByName(selectedAsset) {
      this.info.AssetConditionId = this.assetTypes.find(
        (condition) => condition.Name == selectedAsset
      ).Id;
    },
    findAssetBrandByName(selectedAsset) {
      this.info.AssetBrandId = this.assetBrand.find(
        (brand) => brand.Name == selectedAsset
      ).Id;
    },
    findAssetStatusByName(selectedAsset) {
      this.info.AssetStatusId = this.assetStatuses.find(
        (asset) => asset.Name == selectedAsset
      ).Id;
    },

    // /{organization}/asset/type/v1/request
    getAssetBrand() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/brand/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetBrand = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/asset/type/v1/request
    getAssetCondition() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/condition/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.condition = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/asset/type/v1/request
    getAssetModel() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/model/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetModel = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/asset/type/v1/request
    getAssetTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetTypes = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/asset/type/v1/request
    getAssetStatuses() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/status/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetStatuses = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
